/**
 * Breakpoints
 *
 *    value 0px     561px   961px   1281px
 *    width |-------|-------|-------|------>
 *    key   mobile  tablet  laptop  laptopL
 */
export var Breakpoints = {
  mobile: 0,
  tablet: 561,
  laptop: 961,
  laptopL: 1281
};
export var media = {
  mobile: "screen and (max-width: ".concat(Breakpoints.tablet - 1, "px)"),
  tablet: "screen and (min-width: ".concat(Breakpoints.tablet, "px) and (max-width: ").concat(Breakpoints.laptop - 1, "px)"),
  laptop: "screen and (min-width: ".concat(Breakpoints.laptop, "px) and (max-width: ").concat(Breakpoints.laptopL - 1, "px)"),
  laptopL: "screen and (min-width: ".concat(Breakpoints.laptopL, "px)")
};
//# sourceMappingURL=breakpoints.js.map